if (!customElements.get('wos-product-purchase-bar')) {
  customElements.define('wos-product-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.product = this.closest('wos-personalizer')?.querySelector('.product-section');
      if (!this.product) return;
      this.action = this.querySelector('[data-wos-bar-action]');
      this.amount = this.querySelector('[data-wos-bar-price]');
      this.defaultLabel = this.action.textContent;
      this.update = () => {
        this.frame = null;
        const appPrice = this.product.querySelector('.tee-price--current');
        const nativePrice = this.product.querySelector('[data-product-price]');
        const price = appPrice || nativePrice;
        const text = price?.textContent.trim();
        if (text && this.amount.textContent !== text) this.amount.textContent = text;
        const label = appPrice ? this.dataset.personalizeLabel : this.defaultLabel;
        if (this.action.textContent !== label) this.action.textContent = label;
        const target = appPrice
          ? this.product.querySelector('.tee-field--teeinblue-available-prod, .tee-form')
          : this.product.querySelector('.product-block--native-variant-picker input, .product-block--native-variant-picker select')?.closest('.product-block--native-variant-picker') || this.product.querySelector('form[action*="/cart/add"]');
        if (target && !target.id) target.id = `WosProductOptions-${this.dataset.sectionId}`;
        if (target && this.action.hash !== `#${target.id}`) this.action.hash = target.id;
        const purchase = appPrice
          ? this.product.querySelector('.tee-form-actions')
          : this.product.querySelector('[data-add-to-cart]');
        if (purchase !== this.purchase) {
          this.purchaseObserver?.disconnect();
          this.purchase = purchase;
          this.controlsVisible = false;
          this.visibleControls = new Set();
          if (purchase) {
            this.purchaseObserver = new IntersectionObserver(entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting) this.visibleControls.add(entry.target);
                else this.visibleControls.delete(entry.target);
              });
              this.controlsVisible = this.visibleControls.size > 0;
              this.hidden = !this.amount.textContent || this.controlsVisible;
            }, { rootMargin: '0px 0px -84px 0px' });
            this.purchaseObserver.observe(purchase);
            if (target && target !== purchase) this.purchaseObserver.observe(target);
          }
        }
        const hidden = !text || !target || this.controlsVisible;
        if (this.hidden !== hidden) this.hidden = hidden;
      };
      this.onClick = event => {
        const target = document.getElementById(this.action.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        target.tabIndex = -1;
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
      };
      this.action.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => {
        if (this.frame == null) this.frame = requestAnimationFrame(this.update);
      });
      this.observer.observe(this.product, { childList: true, subtree: true, characterData: true });
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.purchaseObserver?.disconnect();
      this.observer = null;
      cancelAnimationFrame(this.frame);
      this.action?.removeEventListener('click', this.onClick);
    }
  });
}
